import { select } from "redux-saga/effects";
import { call, put } from "redux-saga/effects";
import * as actions from "../actions";
import { selectIde } from "../../features/ide/ideSlice";
import { IdePersistedState, setIdeState } from "../../features/ide/ideSlice";
import { apiGetBrowserState, apiSetBrowserState } from "../../services/BrowserAPI";

export function* saveIdeState() {
  try {
    const ideState = (yield select(selectIde)) as ReturnType<typeof selectIde>;
    const payload: IdePersistedState = {
      lastLocation: ideState.lastLocation,
      history: ideState.history,
    };
    const json = JSON.stringify(payload);
    yield call(apiSetBrowserState, json);
  } catch (e) {
    // Non-fatal: ignore persistence errors
    return;
  }
}

export function* loadIdeState() {
  try {
    const response = yield call(apiGetBrowserState);
    if (response && response.data && response.data.browser_state) {
      try {
        const parsed = JSON.parse(response.data.browser_state.state_json) as IdePersistedState;
        if (parsed && parsed.history) {
          yield put(setIdeState(parsed));
        }
      } catch (e) {
        // ignore parse errors
      }
    }
  } catch (e) {
    // Non-fatal
    return;
  }
}

